import {} from "redux";
import {
  DashboardReduxReducerActionsReturn,
  DashboardReduxReducerUpgradeUserPlanToProServices,
  DashboardReduxReducerUpgradeUserPlanToStandardServices,
} from "../actions/dashboard";

export const DASHBOARD_REDUX_REDUCER_ACTIONS_TYPE = {
  SHOW_UPGRADE_USER_PLAN_TO_PRO_MODAL: "SHOW_UPGRADE_USER_PLAN_TO_PRO_MODAL",
  HIDE_UPGRADE_USER_PLAN_TO_PRO_MODAL: "HIDE_UPGRADE_USER_PLAN_TO_PRO_MODAL",
  SHOW_UPGRADE_USER_PLAN_TO_STANDARD_MODAL: "SHOW_UPGRADE_USER_PLAN_TO_STANDARD_MODAL",
  HIDE_UPGRADE_USER_PLAN_TO_STANDARD_MODAL: "HIDE_UPGRADE_USER_PLAN_TO_STANDARD_MODAL",
} as const;

export interface DashboardReduxReducerState {
  upgradeUserPlanToPro: {
    service?: DashboardReduxReducerUpgradeUserPlanToProServices;
    showModal: boolean;
  };
  upgradeUserPlanToStandard: {
    service?: DashboardReduxReducerUpgradeUserPlanToStandardServices;
    showModal: boolean;
  };
}

export const initialState: DashboardReduxReducerState = {
  upgradeUserPlanToPro: {
    service: undefined,
    showModal: false,
  },
  upgradeUserPlanToStandard: {
    service: undefined,
    showModal: false,
  },
};

function DashboardReduxReducer(
  // eslint-disable-next-line default-param-last
  state: DashboardReduxReducerState = initialState,
  action: DashboardReduxReducerActionsReturn
): DashboardReduxReducerState {
  switch (action.type) {
    case DASHBOARD_REDUX_REDUCER_ACTIONS_TYPE.SHOW_UPGRADE_USER_PLAN_TO_PRO_MODAL:
      return {
        ...state,
        upgradeUserPlanToPro: {
          service: action.payload,
          showModal: true,
        },
      };
    case DASHBOARD_REDUX_REDUCER_ACTIONS_TYPE.HIDE_UPGRADE_USER_PLAN_TO_PRO_MODAL:
      return {
        ...state,
        upgradeUserPlanToPro: {
          service: undefined,
          showModal: false,
        },
      };
    case DASHBOARD_REDUX_REDUCER_ACTIONS_TYPE.SHOW_UPGRADE_USER_PLAN_TO_STANDARD_MODAL:
      return {
        ...state,
        upgradeUserPlanToStandard: {
          service: action.payload,
          showModal: true,
        },
      };
    case DASHBOARD_REDUX_REDUCER_ACTIONS_TYPE.HIDE_UPGRADE_USER_PLAN_TO_STANDARD_MODAL:
      return {
        ...state,
        upgradeUserPlanToStandard: {
          service: undefined,
          showModal: false,
        },
      };

    default:
      return state || initialState;
  }
}

export default DashboardReduxReducer;
